import { defineStore } from 'pinia'

interface Obj {
  [key: string]: any
}
interface HeaderState {
  show_create_project_popup: boolean
  select_template_popup: boolean
  show_feedback_popup: boolean
  createProjectPramas: Obj | null
}

export const useHeaderStore = defineStore('header', {
  state: (): HeaderState => ({
    show_create_project_popup: false,
    select_template_popup: false,
    show_feedback_popup: false,
    createProjectPramas: null,
  }),
  getters: {},
  actions: {
    showCreateProjectPopup(payload?: Obj) {
      if (payload) {
        this.createProjectPramas = payload
      }
      this.show_create_project_popup = true
    },
    hideCreateProjectPopup() {
      this.show_create_project_popup = false
      this.createProjectPramas = null
    },
    showSelectTemplatePopup() {
      this.select_template_popup = true
    },
    hideSelectTemplatePopup() {
      this.select_template_popup = false
    },
    showFeedbackPopup() {
      this.show_feedback_popup = true
    },
    hideFeedbackPopup() {
      this.show_feedback_popup = false
    },
  },
})
